import makeRequest from './base.request'

export const getNotasTRI = async (idStudent, nuPeriod = 0, idPracticeTestType = 0) => {
    try {
        const student = idStudent ? '?student=' + idStudent : ''
        const response = await makeRequest.get(`acompanhamento/notatri${student}${nuPeriod?`&period=${nuPeriod}`:``}${idPracticeTestType?`&practicetesttype=${idPracticeTestType}`:``}`);

        var notas = response.medias[0];
        return notas;
    } catch (error) {
        console.error(error);
    }
}

export const getNotasTRISerie = async (idGrade, nuPeriod = 0, idPracticeTestType = 0, lstIdClass = []) => {
    try {

        var idClass = lstIdClass.join(',');
        const response = await makeRequest.get(`acompanhamento/notatri-serie?grade=${idGrade}${nuPeriod?`&period=${nuPeriod}`:``}${idPracticeTestType?`&practicetesttype=${idPracticeTestType}`:``}${idClass?`&class=${idClass}`:``}`);

        var notas = response.medias[0];
        return notas;
    } catch (error) {
        console.error(error);
    }
}

export const getMediasDisciplina = async (idStudent, nuPeriod = 0, idPracticeTestType = 0) => {
    try {
        const student = idStudent ? '?student=' + idStudent : ''
        const response = await makeRequest.get(`acompanhamento/medias-disciplina${student}${nuPeriod?`&period=${nuPeriod}`:``}${idPracticeTestType?`&practicetesttype=${idPracticeTestType}`:``}`);

        var notas = response.medias[0];
        // console.log(notas)
        return notas;
    } catch (error) {
        console.error(error);
    }
}

export const getMediasHabilidade = async (idStudent, nuPeriod = 0, idPracticeTestType = 0) => {
    try {
        const student = idStudent ? '?student=' + idStudent : ''
        const response = await makeRequest.get(`acompanhamento/medias-habilidade${student}${nuPeriod?`&period=${nuPeriod}`:``}${idPracticeTestType?`&practicetesttype=${idPracticeTestType}`:``}`);

        var notas = response.medias[0];
        // console.log(notas)
        return notas;
    } catch (error) {
        console.error(error);
    }
}

export const getMediasDisciplinaSerie = async (idGrade, nuPeriod = 0, idPracticeTestType = 0, lstIdClass = []) => {
    try {
        var idClass = lstIdClass.join(',');
        const response = await makeRequest.get(`acompanhamento/medias-disciplina-serie?grade=${idGrade}${nuPeriod?`&period=${nuPeriod}`:``}${idPracticeTestType?`&practicetesttype=${idPracticeTestType}`:``}${idClass?`&class=${idClass}`:``}`);

        var notas = response.medias[0];
        // console.log(notas)
        return notas;
    } catch (error) {
        console.error(error);
    }
}

export const getMediasHabilidadeSerie = async (idGrade, nuPeriod = 0, idPracticeTestType = 0, lstIdClass = []) => {
    try {
        var idClass = lstIdClass.join(',');
        const response = await makeRequest.get(`acompanhamento/medias-habilidade-serie?grade=${idGrade}${nuPeriod?`&period=${nuPeriod}`:``}${idPracticeTestType?`&practicetesttype=${idPracticeTestType}`:``}${idClass?`&class=${idClass}`:``}`);

        var notas = response.medias[0];
        // console.log(notas)
        return notas;
    } catch (error) {
        console.error(error);
    }
}

export const getListaAlunosSerie = async (idGrade, nuPeriod = 0, idPracticeTestType = 0, lstIdClass = []) => {
    try {
        var idClass = lstIdClass.join(',');
        const response = await makeRequest.get(`acompanhamento/alunos-serie?grade=${idGrade}${nuPeriod?`&period=${nuPeriod}`:``}${idPracticeTestType?`&practicetesttype=${idPracticeTestType}`:``}${idClass?`&class=${idClass}`:``}`);

        var lista = response.lista[0];
        return lista;
    } catch (error) {
        console.error(error);
    }
}

export const getListaAtividadesAluno = async (nuPeriod, idPracticeTestType, idStudent = 0) => {
    try {
        const response = await makeRequest.get(`acompanhamento/atividades-aluno-periodo?period=${nuPeriod}&practicetesttype=${idPracticeTestType}${idStudent?`&student=${idStudent}`:``}`);

        var lista = response.medias[0];
        return lista;
    } catch (error) {
        console.error(error);
    }
}

export const getListaDeAtividadesPorAlunoESimulado = async (idStudent, idExam) => {
    try {
        const response = await makeRequest.get(`acompanhamento/atividades-aluno?student=${idStudent}&exam=${idExam}`);
        return response;
    } catch (error) {
        console.error(error);
    }
}